import React from 'react'
import Navbar from '../inc/Navbar'
import villa4bhk from "../images/4 BHK VILLA photo.jpg";
import { Link } from "react-router-dom";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import villa4bhknew from "../images/4bhk villa.jpg";
import villa4bhkinterior from "../images/Interior Villa.jpg";
import LogoSlider from './LogoSlider';

import bhk4krishnagar from "../images/4bhk new photo.jpg"
import bhk4villaluxury from "../images/4BHK villa plot complete.jpg";
import luxuryvillaplots from "../images/4BHK plot.jpg";
import villasaleready from "../images/READY VILLA SALE.jpg"

function Bhk4villa() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <div className='krishnagarland'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "white" }}>Home</Link></li>
                                <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page">4BHK VILLA</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>     
            <div style={{ color: "white", padding: "14px;", margin: 10 }} className="fixed-bottom "> <a style={{ color: "white" }} href="tel: 8918782294" className="srgcomplexkrishnagar" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </svg> Call Us <div className="spinner-grow text-light spinner-grow-sm" role="status">
          <span className="visually-hidden"> Loading...</span>
        </div> </a></div>

            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 style={{ color: "#B80000" }} className="card-title mb-0"><b> 4BHK <b>VILLA</b></b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>

                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Luxury 4BHK <b>Villa Krishnagar</b></h3>
                                            <p style={{ color: "#1D4D93" }} className='mb-2'>Dear Visitors,</p>

                                            <p className='justify mb-2'>🏡 Affordable Residential Plot with Construction – Prime Location</p>
                                            <p className='justify mb-1'>Approximate budget ₹65,00,000 only.
                                                Built-up area around 1650 sq. ft.
                                                Plot size 2.5 Katha (minimum 2 Katha available).
                                                Wide approach roads – 22 feet & 18 feet road access.
                                                Ideal for residential construction in a well-connected locality.
                                                Perfect choice for families looking for value, space, and convenience.</p>

                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={villa4bhk} className="card-img-top" alt="villa3bhk" />


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
 <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={bhk4villaluxury} className="card-img-top" alt="bhk4villaluxury"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">4BHK Villa</p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={luxuryvillaplots} className="card-img-top" alt="luxuryvillaplots"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">4BHK Villa </p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                  
  <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={bhk4krishnagar} className="card-img-top" alt="bhk4krishnagar" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Villa Interior</p>
                                             
                                              
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={villasaleready} className="card-img-top" alt="villasaleready"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >SRG COMPLEX                               </h5>
                                                <p className="card-text">4BHK Villa </p>
                                              
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={villa4bhknew} className="card-img-top" alt="villa4bhk"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">4 BHK Villa</p>
                                          

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={villa4bhkinterior} className="card-img-top" alt="villa4bhkinterior"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SRG COMPLEX </h5>
                                                <p className="card-text">Foura Water Design</p>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                  

                    </div>
                </div>
            </div>
            <LogoSlider/>
            <br/>
        </div>
    )
}

export default Bhk4villa